import i18n from 'i18next';
import {initReactI18next} from 'react-i18next';
import {fr as commonFR} from './common/fr';
import {en as commonEN} from './common/en';
import {de as commonDE} from './common/de';

export const resources = {
  fr: {
    common:commonFR,
  },
  en: {
    common:commonEN,
  },
  de: {
    common: commonDE,
  },
} as const;

const availableLocales = ['fr', 'en', 'de'];
const availableNamespaces = ['common'];
const defaultLocale = 'fr';
const defaultNamespace = 'common';

export const i18nConfig = (locale: string) => {
  i18n
    .use(initReactI18next)
    .init({
      defaultNS: defaultNamespace,
      ns: availableNamespaces,
      resources,
      lng: locale,
      fallbackLng: defaultLocale,
      interpolation: {
        escapeValue: false 
      },
      debug: true
    });
};
  
export {availableLocales, availableNamespaces, defaultLocale, defaultNamespace};
